import { fetcher } from '@commenda/utils';
import {
  IIndirectTaxBulkUpdateStatusV2Params,
  IIndirectTaxBulkUpdateStatusV2Response,
} from './types';

export async function updateIndirectTaxRegistrationsStatusBulk(
  params: IIndirectTaxBulkUpdateStatusV2Params
): Promise<{
  success: boolean;
  data?: IIndirectTaxBulkUpdateStatusV2Response;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/registrations-v2/bulk/registration-status',
      { method: 'POST', body: params },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update status',
      };
    }

    const data: IIndirectTaxBulkUpdateStatusV2Response = await response.json();
    return {
      success: true,
      data,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update status';
    return {
      success: false,
      error: errorMessage,
    };
  }
}
